import { NgModule } from "@angular/core";
import { DefaultModules } from "../services/app.constants";
import { HeaderComponent } from "./components/header/header.component";
import { HeaderService } from "./components/header/header.service";
import { ThemeService } from "./components/theme.service";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ShellLayoutComponent } from "./components/layout/shell-layout.component";
import { EmptyLayoutComponent } from "./components/layout/empty-layout/empty-layout.component";
import { NgbModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { NewsAnimatorComponent } from "./components/news-animator/news-animator.component";
import { LoginLayoutComponent } from "./components/layout/login-layout/login-layout.component";
import { FormsModule } from "@angular/forms";
import { OnlyHeaderLayoutComponent } from "./components/layout/only-header-layout/only-header-layout.component";
import { PaddedLayoutComponent } from "./components/layout/padded-layout/padded-layout.component";
import { SidebarComponent } from "./components/sidebar/sidebar.component";
import { AutoCompleteModule } from "primeng/autocomplete";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { FriendsSearchPipe } from "./components/sidebar/friends-search.pipe";
import { DialogModule } from "primeng/dialog";
import { SettingsModule } from "../pages/settings/settings.module";
import { HeaderNotificationsModule } from "../pages/components/header-notifications/header-notifications.module";
import { CommunitiesSearchPipe } from "./components/sidebar/communities-search.pipe";
import { EventsSearchPipe } from "./components/sidebar/events-search.pipe";
import { DropdownModule } from "primeng/dropdown";

const components = [
    HeaderComponent,
    ShellLayoutComponent,
    EmptyLayoutComponent,
    NewsAnimatorComponent,
    LoginLayoutComponent
];
const modules = [
    TranslateModule.forChild(),
    NgbModule,
    BrowserAnimationsModule,
    FormsModule,
    NgbTooltipModule,
    HeaderNotificationsModule,
    AutoCompleteModule,
    ScrollPanelModule,
    DialogModule,
    SettingsModule,
    DropdownModule,
];
const providers = [
    HeaderService,
    ThemeService
];

@NgModule({
    imports: [...DefaultModules, ...modules],
    exports: [...components],
    providers: [...providers],
    declarations: [...components, OnlyHeaderLayoutComponent, PaddedLayoutComponent, SidebarComponent, FriendsSearchPipe, CommunitiesSearchPipe, EventsSearchPipe],
})
export class ThemeModule {

}